import React from "react";
import { Play, Pause, Plus } from "lucide-react";
import { usePlayer } from "../context/PlayerContext";

export default function TrackCard({ track, onAddToPlaylist }) {
  const { track: current, playing, playTrack } = usePlayer();
  const isCurrent = current?.id === track.id;

  return (
    <div className="card-tactile led-card group relative overflow-visible" data-testid={`track-card-${track.id}`}>
      <div className="relative aspect-square overflow-hidden">
        <img src={track.cover_url} alt={track.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-80" />
        <button
          onClick={() => playTrack(track, { preview: true })}
          className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
          data-testid={`play-track-${track.id}`}
        >
          <div className="w-16 h-16 bg-[#FF5E00] flex items-center justify-center shadow-[0_0_40px_rgba(255,94,0,0.6)]">
            {isCurrent && playing ? <Pause className="w-6 h-6" /> : <Play className="w-6 h-6 ml-1" />}
          </div>
        </button>
        <div className="absolute top-3 left-3 text-[10px] font-mono-plex uppercase tracking-widest bg-black/70 backdrop-blur px-2 py-1 border border-white/10">
          €3
        </div>
        <div className="absolute top-3 right-3 text-[10px] font-mono-plex uppercase tracking-widest text-[#B3FF00] bg-black/70 backdrop-blur px-2 py-1 border border-[#B3FF00]/30">
          {track.duration}
        </div>
      </div>
      <div className="p-4">
        <div className="text-[10px] font-mono-plex uppercase tracking-[0.25em] text-[#B3FF00] mb-1">{track.genre}</div>
        <h3 className="font-display font-bold text-lg truncate">{track.title}</h3>
        <p className="text-xs text-white/50 mt-1 line-clamp-2">{track.description}</p>
        {onAddToPlaylist && (
          <button onClick={() => onAddToPlaylist(track)} className="mt-3 flex items-center gap-1 text-xs font-mono-plex uppercase tracking-widest text-white/60 hover:text-[#FF5E00]" data-testid={`add-to-playlist-${track.id}`}>
            <Plus className="w-3 h-3" /> Playlist
          </button>
        )}
      </div>
    </div>
  );
}
